import {t} from "i18next";

export const buildCharacteristicsText = (skuPlan, language = "en") => {
  const characteristics = [];
  const label = key => t(key);

  const materialName =
    skuPlan?.material?.[language === "en" ? "engName" : "name"]?.trim() ||
    skuPlan?.material?.[language === "en" ? "name" : "engName"]?.trim() ||
    (typeof skuPlan?.material === "string" ? skuPlan?.material?.trim() : "") ||
    skuPlan?.materialType;

  if (materialName) {
    characteristics.push(`${label("Finishing")}: ${materialName}`);
  }

  if (skuPlan?.color) {
    characteristics.push(`${label("Color")}: ${skuPlan.color}`);
  }

  if (skuPlan?.collectionCheck && skuPlan?.collectionName) {
    characteristics.push(`${label("Collection")}: ${skuPlan.collectionName}`);
  }

  if (skuPlan?.brandCheck && skuPlan?.brandName) {
    characteristics.push(`${label("Brand ")}: ${skuPlan.brandName}`);
  }
  if (skuPlan?.batchCheck && skuPlan?.batch) {
    characteristics.push(`${label("Batch")}: ${skuPlan.batch}`);
  }
  if (skuPlan?.productSeriesCheck && skuPlan?.productSeries) {
    characteristics.push(`${label("Series")}: ${skuPlan.productSeries}`);
  }

  return characteristics.join(", \n");
};
